<div class="card">
  <p-steps [model]="steps" [activeIndex]="currentStep"></p-steps>

  <div class="mt-4">
    <ng-container [ngSwitch]="currentStep">
      <!-- Step 1: Payment Details Form -->
      <div *ngSwitchCase="0">
        <tj-payment-details-form
          [form]="form"
          [paymentDetails]="paymentDetails"
          [paymentConfig]="paymentConfig"
          [itemType]="itemType"
          (formValid)="onFormValid($event)"
          (nextStep)="onNextStep()"
        ></tj-payment-details-form>
      </div>

      <!-- Step 2: Payment Method -->
      <div *ngSwitchCase="1">
        <tj-payment-method
          [form]="form"
          [paymentDetails]="paymentDetails"
          [paymentMethodIndex]="paymentMethodIndex"
          [vaultId]="vaultId"
          (back)="onStepBack()"
          (paymentStatus)="onPaymentStatus($event)"
        ></tj-payment-method>
      </div>

      <!-- Step 3: Payment Status -->
      <div *ngSwitchCase="2">
        <tj-payment-status
          [paymentStep]="paymentStep"
          [orderData]="orderData"
          [error]="lastError"
          [itemType]="itemType"
          [items]="items"
          (backToPayment)="backToPayment()"
        ></tj-payment-status>
      </div>
    </ng-container>
  </div>
</div>
